import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/kriteria-icu`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/kriteria-icu/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function create(data: any) {
  const response = await http.postData("/kriteria-icu", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id: number, data: any) {
  const response = await http.putData(`/kriteria-icu/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/kriteria-icu/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signMasuk(id: number, data: { password: string }) {
  const response = await http
    .postData(`/kriteria-icu/${id}/sign-masuk`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signKeluarDpjp(id: number, data: { password: string }) {
  const response = await http
    .postData(`/kriteria-icu/${id}/sign-keluar-dpjp`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signKeluarPpja(id: number, data: { password: string }) {
  const response = await http
    .postData(`/kriteria-icu/${id}/sign-keluar-ppja`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/kriteria-icu/${id}/pdf`, "_blank");
}

function printPdfMasuk(id: number) {
  window.open(`${http.getAPI()}/kriteria-icu/${id}/pdf?section=masuk`, "_blank");
}

function printPdfKeluar(id: number) {
  window.open(`${http.getAPI()}/kriteria-icu/${id}/pdf?section=keluar`, "_blank");
}

export default {
  getByRegister,
  find,
  create,
  update,
  destroy,
  signMasuk,
  signKeluarDpjp,
  signKeluarPpja,
  printPdf,
  printPdfMasuk,
  printPdfKeluar,
};
